import * as constants from './constants';
import { PopupAction } from './action';

export interface IPopupState {
  anyPopupOpen: boolean;
  changePasswordOpen: boolean;
  deleteDialogOpen: boolean;
}

export const initialState: IPopupState = {
  anyPopupOpen: false,
  changePasswordOpen: false,
  deleteDialogOpen: false,
}

export const reducer = (state: IPopupState = initialState, action: PopupAction): IPopupState => {
  switch(action.type) {
    case constants.OPEN_CHANGE_PASSWORD:
      return {
        ...state,
        anyPopupOpen: true,
        changePasswordOpen: true
      }
    case constants.CLOSE_CHANGE_PASSWORD:
      return {
        ...state,
        anyPopupOpen: false,
        changePasswordOpen: false
      }
    case constants.OPEN_DELETE_DIALOG:
      return {
        ...state,
        anyPopupOpen: true,
        deleteDialogOpen: true
      }
    case constants.CLOSE_DELETE_DIALOG:
      return {
        ...state,
        anyPopupOpen: false,
        deleteDialogOpen: false
      }
    /* istanbul ignore next */
    default:
      return {
        ...state
      };
  }
}


// WEBPACK FOOTER //
// ./src/modules/popup/reducer.ts